import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { TextInput, FormLabel, Tooltip} from 'carbon-components-react';


const FormInput = ({label, name, type, disabled, onChange, helperText, tooltipText, props}) => {
    const {register, formState, watch, setValue, trigger} = useFormContext(); 
    const [objValue, setObjValue] = useState(null);
    const watcher = watch(name);
    let obj = formState.errors[name];
    

    const array = name.substr(0, name.indexOf("["));
    if(array.length > 0){
        const optionalName = name.replace('.', '?.');
        obj = formState.errors[array] ? eval(`formState.errors.${optionalName}`) : null;
    }

    let prefix = "";
    let normalize = "";

    if(type === "tel") {
        normalize = type;
        if(!helperText){
            helperText = "xxx-xxx-xxxx";
        }
    } else if(type === "currency"){
        type = "number";
        prefix = "currency-input";
    } else if(type === "ssn") {
        normalize = type;
        type = "tel";
    } 

    const refreshObj = () => {
        if(array.length > 0){
            const optionalName = name.replace('.', '?.');
            obj = formState.errors[array] ? eval(`formState.errors.${optionalName}`) : null;
        }
    }

    useEffect(() => {
        if(!watcher)
            setObjValue(null);
        else
            setObjValue(watcher);
        
        refreshObj();

    }, [watcher]);

    const formatSsn = (value) => {
        return value.match(/\d*/g).join('')
        .match(/(\d{0,3})(\d{0,2})(\d{0,4})/).slice(1).join('-')
        .replace(/-*$/g, '');
    }

    const formatUsPhone = (value) => {
        return value.match(/\d*/g).join('')
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/).slice(1).join('-')
        .replace(/-*$/g, '');
    }

    const change = (e) => {
        if(normalize === "ssn"){
            e.target.value = formatSsn(e.target.value);
        } else if(normalize === "tel"){
            e.target.value = formatUsPhone(e.target.value);
        }
        if(e)
            setValue(name, e.target.value);

        if(onChange)
            onChange(e.target.value);
            
        trigger(name);

    }


    return (  
        <div className="mb-6">
        <FormLabel>
            {
            tooltipText ?
            <Tooltip triggerText={label}>
                {tooltipText}
            </Tooltip> 
            : <>{label}</>
            }
        </FormLabel>
            <span className={prefix}>
                <TextInput 
                    id={`txt-${name}`} {...register(name)} 
                    invalidText={obj?.message} 
                    invalid={!!obj} 
                    helperText={helperText} 
                    type={type} 
                    disabled={disabled}
                    min={0}
                    step={.01}
                    labelText="" 
                    hideLabel={true} 
                    onChange={change} 
                    {...props} 
                />
            </span>
        </div>
    );
}
 
export default FormInput;